module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/wav-logo.png",
      "alt": "logo",
      "height": "30px"
    }
  }), _vm._v(" "), (_vm.isSignedIn) ? _c('div', {
    staticClass: "message"
  }, [_c('h2', {
    staticClass: "success"
  }, [_vm._v("Successfully Logged In!")]), _vm._v(" "), _c('p', [_vm._v("Welcome back! You are now signed in.")])]) : _c('div', {
    staticClass: "message"
  }, [_c('h2', {
    staticClass: "error"
  }, [_vm._v("Login link has been expired")]), _vm._v(" "), _c('p', [_vm._v("Please check your login credentials or try signing in again.")])]), _vm._v(" "), (!_vm.isSignedIn) ? _c('a', {
    staticClass: "button",
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("\n      Sign In\n    ")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-721f8d9b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/completeSignin.vue
// module id = 528
// module chunks = 17